import React from 'react';
import { useDropzone } from 'react-dropzone';
import styles from './DropZone.module.css';

function Dropzone(props) {
    // const uploadFile = props.uploadFile;
    const onDrop = props.onDrop;
    // const multiple = props.multiple;

    // Handle file drop
    // const onDrop = (acceptedFiles) => {
    //     if (multiple) {
    //         acceptedFiles.forEach((file) => {
    //             uploadFile(file);
    //         });
    //     } else {
    //         uploadFile(acceptedFiles[0]);
    //     }
    // };

    // Create dropzone with the given onDrop handler
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

    return (
        <div className={`${styles.container} container mt-2`}>
            <div className={styles.dropzone} {...getRootProps()}>
                <label htmlFor="files" className={`${styles.dropzoneContainer} text-dark`}>
                    {/* <div className="bi bi-file-earmark-arrow-up h1">+</div> */}
                    {/* <i class="bi-alarm"></i>
                    <i class="file-icon"></i>
                    <i class="bi bi-file-earmark-arrow-up-fill"></i> */}
                    <i class="bi bi-file-earmark-arrow-up h1"></i>
                    <div className={styles.dropzoneTitle}>
                        Drag and drop your files or <span className={styles.browse}>browse</span> your files
                        {
                            isDragActive ?
                            <p>Drop the files here ...</p> :
                            <p>Drag 'n' drop some files here, or click to select files</p>
                        }
                    </div>
                </label>
                <input
                    type="file"
                    name="files"
                    className={styles.fileInput}
                    multiple
                    {...getInputProps()}
                />
            </div>
        </div>
    );
}

export default Dropzone;